import OfferEvent from './OfferEvent';

export default class SuperOffer {
    superExtra: OfferEvent[];
    superKvota: OfferEvent[];
    topTen: OfferEvent[];
    [key: string]: OfferEvent[];
}
